import { render, staticRenderFns } from "./appLeaveGrantedFinalInstructions.vue?vue&type=template&id=3ef0966a"
import script from "./appLeaveGrantedFinalInstructions.vue?vue&type=script&lang=ts"
export * from "./appLeaveGrantedFinalInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports